import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "How to run JavaScript tests in Chrome on Travis",
  "description": "",
  "published": "2015-01-27T00:00:00.000Z",
  "redirect_from": ["/blog/how-to-run-javascript-tests-in-chrome-on-travis/swizec/6647"],
  "categories": "Github, JavaScript, karma, Stack Overflow, Technical, testing",
  "hero": "./img/images-26240.png"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><figure parentName="p" {...{
        "className": "gatsby-resp-image-figure",
        "style": {
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
    `}<span parentName="figure" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "783px"
          }
        }}>{`
      `}<a parentName="span" {...{
            "className": "gatsby-resp-image-link",
            "href": "/static/be3fb5869142258af2d353376be9672e/e51a6/images-26240.png",
            "style": {
              "display": "block"
            },
            "target": "_blank",
            "rel": "noopener"
          }}>{`
    `}<span parentName="a" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "16.591928251121075%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'67\\'%20viewBox=\\'0%200%20400%2067\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M5%2019v12h24V7H5v12m166%2017l-3%201-2%202h-1c0-2-1-2-6-2h-6c-1-2-4%200-4%202l-1%201-1-1v-2l-1%202c1%203%204%204%204%201%200-2%200-2%201-1%201%203%209%203%209%201s0-2%201%200%201%202%202%201l1-1c0%202%206%203%206%200h1c0%202%201%202%208%202h7v-4c0-3%200-3-1-2-2%202-10%202-10%200l-1-1-1%201h-2m52%200l-14%201h-13v3c0%202%200%202%201%201%201-2%201-2%201%200%201%201%201%201%202-1s1-2%201%200%203%202%206%201h1l1-1%201-2%201%202c0%203%204%204%204%201h12l-1-1-1-2c0-3-2-4-2-2m81%200v9l1%208h80V36l-40-1-41%201M84%2037c-3%200-4%203-2%205l1-2h1c1%202%202%202%203%202h9l2-1h1l7%201c5%200%205%200%205-3-1-2-4-3-6-2h-4l-4%202h-1c0-2-2-3-2-1h-1l-3-1h-6\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/be3fb5869142258af2d353376be9672e/ca0a1/images-26240.webp 223w", "/static/be3fb5869142258af2d353376be9672e/75680/images-26240.webp 445w", "/static/be3fb5869142258af2d353376be9672e/b408c/images-26240.webp 783w"],
                "sizes": "(max-width: 783px) 100vw, 783px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/be3fb5869142258af2d353376be9672e/e92b6/images-26240.png 223w", "/static/be3fb5869142258af2d353376be9672e/e66bf/images-26240.png 445w", "/static/be3fb5869142258af2d353376be9672e/e51a6/images-26240.png 783w"],
                "sizes": "(max-width: 783px) 100vw, 783px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/be3fb5869142258af2d353376be9672e/e51a6/images-26240.png",
                "alt": "Pull request feedback",
                "title": "Pull request feedback",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
          "className": "gatsby-resp-image-figcaption"
        }}>{`Pull request feedback`}</figcaption>{`
  `}</figure></p>
    <p>{`You test your frontend code, right? And you've got a continuous integration system running, right? `}<em parentName="p">{`Right?`}</em></p>
    <p>{`Well you should.`}</p>
    <p>{`Code review is `}<em parentName="p">{`a lot`}</em>{` easier when you have a magical system to say All Is Well. At least in principle. There are limits to testing, but that's a whole different bag of worms.`}</p>
    <p>{`Today I want to share a little nugget that took hours of interneting to find. Thanks to everyone in `}<a parentName="p" {...{
        "href": "http://stackoverflow.com/questions/19255976/how-to-make-travis-execute-angular-tests-on-chrome-please-set-env-variable-chr"
      }}>{`this`}</a>{` and other Stack Overflow threads for originally figuring it out.`}</p>
    <h2 {...{
      "id": "the-moving-parts"
    }}>{`The moving parts`}</h2>
    <p>{`First you will need `}<a parentName="p" {...{
        "href": "http://karma-runner.github.io/0.12/index.html"
      }}>{`karma-runner`}</a>{`. It is the single best JavaScript test runner I have ever used.`}</p>
    <p>{`Runs in the background when you're working, re-runs tests on file change, and doesn't care whether you're using Jasmine, Mocha, or something else.`}</p>
    <p>{`And it's so very very fast.`}</p>
    <p>{`Next you will need `}<a parentName="p" {...{
        "href": "https://travis-ci.org/"
      }}>{`Travis`}</a>{`.`}</p>
    <p>{`Any continuous integration service will do really - I've had great success with Circle CI. But this post is about Travis in particular.`}</p>
    <p>{`You want something that replicates your environment on a server, runs the tests every time you push to a branch, and shows you the result where it matters most. In the pull request.`}</p>
    <h2 {...{
      "id": "the-problem"
    }}>{`The problem`}</h2>
    <p>{`When you're working Karma runs in the terminal. That's where you see the output. But the tests themselves run in a browser or two.`}</p>
    <p>{`You point a browser at `}<inlineCode parentName="p">{`http://localhost:9678`}</inlineCode>{` and Karma handles the rest.`}</p>
    <p>{`All fine and good. But you can't do that on Travis. Not directly at least.`}</p>
    <p>{`People usually resort to PhantomJS. A headless browser that's happy without a GUI. But sometimes your JavaScript doesn't run well in PhantomJS.`}</p>
    <p>{`I'm currently using CanJS, for instance. It uses a thing that doesn't work in current versions of PhantomJS. It's going to work in the future when PhantomJS catches up. But it doesn't yet.`}</p>
    <p><a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Google_Chrome",
        "title": "Google Chrome"
      }}>{`Chrome`}</a>{` is the only option.`}</p>
    <h2 {...{
      "id": "the-solution"
    }}>{`The solution`}</h2>
    <p>{`Luckily, Travis boxes come with Chrome pre-installed. We just have to tweak our configuration to use it.`}</p>
    <p>{`First we have to use `}<inlineCode parentName="p">{`.travis.yml`}</inlineCode>{` to convince the shell we've got a screen after all.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-yaml"
      }}>{`before_install:
  - export CHROME_BIN=chromium-browser
  - export DISPLAY=:99.0
  - sh -e /etc/init.d/xvfb start
`}</code></pre>
    <p>{`We did three things:`}</p>
    <ul>
      <li parentName="ul">{`set `}<inlineCode parentName="li">{`CHROME_BIN`}</inlineCode>{` as chromium-browser, because that's what's installed`}</li>
      <li parentName="ul">{`set up a fake `}<inlineCode parentName="li">{`DISPLAY`}</inlineCode></li>
      <li parentName="ul">{`ran `}<inlineCode parentName="li">{`xvfb`}</inlineCode>{`, which is a sort of GUI environment faker thingy. I'm not certain how it works, but it always shows up in these kinds of things.`}</li>
    </ul>
    <p>{`Then we uuse `}<inlineCode parentName="p">{`karma.conf.js`}</inlineCode>{` to let Karma know, we need a special browser for Travis.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`var configuration = {
  // other things

  customLaunchers: {
    Chrome_travis_ci: {
      base: "Chrome",
      flags: ["--no-sandbox"],
    },
  },
};

if (process.env.TRAVIS) {
  configuration.browsers = ["Chrome_travis_ci"];
}

config.set(configuration);
`}</code></pre>
    <p>{`We created a custom browser launcher that runs Chrome with the `}<inlineCode parentName="p">{`--no-sandbox`}</inlineCode>{` option. And we only use it if the tests are running in Travis.`}</p>
    <p>{`Simple.`}</p>
    <p>{`Our tests run both locally and on Travis. Rejoice!`}</p>
    <p><figure parentName="p" {...{
        "className": "gatsby-resp-image-figure",
        "style": {
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
    `}<span parentName="figure" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "890px"
          }
        }}>{`
      `}<a parentName="span" {...{
            "className": "gatsby-resp-image-link",
            "href": "/static/babb06de70d8ec9184fa36cbf06059ed/1628f/images-26241.png",
            "style": {
              "display": "block"
            },
            "target": "_blank",
            "rel": "noopener"
          }}>{`
    `}<span parentName="a" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "16.143497757847534%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'65\\'%20viewBox=\\'0%200%20400%2065\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M0%2033v32h401V0H0v33\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/babb06de70d8ec9184fa36cbf06059ed/ca0a1/images-26241.webp 223w", "/static/babb06de70d8ec9184fa36cbf06059ed/75680/images-26241.webp 445w", "/static/babb06de70d8ec9184fa36cbf06059ed/8d1ba/images-26241.webp 890w", "/static/babb06de70d8ec9184fa36cbf06059ed/46ece/images-26241.webp 1232w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/babb06de70d8ec9184fa36cbf06059ed/e92b6/images-26241.png 223w", "/static/babb06de70d8ec9184fa36cbf06059ed/e66bf/images-26241.png 445w", "/static/babb06de70d8ec9184fa36cbf06059ed/4ef49/images-26241.png 890w", "/static/babb06de70d8ec9184fa36cbf06059ed/1628f/images-26241.png 1232w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/babb06de70d8ec9184fa36cbf06059ed/4ef49/images-26241.png",
                "alt": "Karma success",
                "title": "Karma success",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
          "className": "gatsby-resp-image-figcaption"
        }}>{`Karma success`}</figcaption>{`
  `}</figure></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      